var render = function render(){var _vm=this,_c=_vm._self._c;return (!this.$store.state.api.isAuthenticated)?_c('section',{staticClass:"Authenticator"},[_c('div',{staticClass:"Authenticator__iframe"},[_c('div',{staticClass:"Authenticator__iframe-background"}),(!this.$store.state.api.isLogout)?_c('LoginWindow',{staticClass:"Authenticator__iframe-window"}):_c('LogoutWindow')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }